import { render, staticRenderFns } from "./Vulnerability.vue?vue&type=template&id=c99d6d14&"
import script from "./Vulnerability.vue?vue&type=script&lang=js&"
export * from "./Vulnerability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c99d6d14')) {
      api.createRecord('c99d6d14', component.options)
    } else {
      api.reload('c99d6d14', component.options)
    }
    module.hot.accept("./Vulnerability.vue?vue&type=template&id=c99d6d14&", function () {
      api.rerender('c99d6d14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/portfolio/vulnerabilities/Vulnerability.vue"
export default component.exports